import React, { useState } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MenuIcon } from './icons/MenuIcon';
import { MenuLinks } from './links/MenuLinks';
import { MenuLinkDataProps } from './links/MenuLink';
import { EditionDataProps } from '../Editions';
import { MEDIA_BREAKPOINTS } from '../../../../../../mediaQueries.const';

export interface MenuDataProps {
  menu: MenuLinkDataProps[]
  editions: EditionDataProps[] | null
  editionEndpoint: string
}

const getMenuStyle = () => StyleSheet.create({
  style: {
    [MEDIA_BREAKPOINTS.LARGE]: {
      display: 'none',
    },
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      display: 'inline-flex',
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      display: 'inline-flex',
    },
  },
});

export const Menu: React.FunctionComponent<MenuDataProps> = props => {
  const [state, setState] = useState({
    isMenuOpen: false,
    currentOpenLink: -1,
  });
  const { isMenuOpen, currentOpenLink } = state;

  const clickOnMenuIcon = () => {
    setState({
      isMenuOpen: !isMenuOpen,
      currentOpenLink: isMenuOpen ? currentOpenLink : -1,
    });
  };

  const clickOnLinkDropDown = (index: number) => {
    setState({
      isMenuOpen,
      currentOpenLink: currentOpenLink === index ? -1 : index,
    });
  };

  const { menu, editions, editionEndpoint } = props;
  const style = getMenuStyle();
  return (
    <div className={css(style.style)}>
      <MenuIcon isMenuOpen={isMenuOpen} onClick={clickOnMenuIcon} />
      <MenuLinks menuLinks={menu} editions={editions} isMenuOpen={isMenuOpen} onClick={clickOnLinkDropDown} currentOpenLink={currentOpenLink} editionEndpoint={editionEndpoint} />
    </div>
  );
};
